module.exports = __webpack_public_path__ + "assets/img/address.72ab8091.svg";